import { render, staticRenderFns } from "./Restaurant.vue?vue&type=template&id=f5b258ec&scoped=true&"
import script from "./Restaurant.vue?vue&type=script&lang=js&"
export * from "./Restaurant.vue?vue&type=script&lang=js&"
import style0 from "./Restaurant.vue?vue&type=style&index=0&id=f5b258ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b258ec",
  null
  
)

export default component.exports